import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DEFAULT_DIALOG_NO_PADDING_CLASS, ScrollService, WindowService } from "@merri/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { VisionboardItem } from "../../models";
import { VisionboardCategoriesService } from "../../services";
import { ForceVisionboardItemAddRemoveButton } from "../../shared/components";
import { VisionboardItemAddRemoveButtonService } from "../../shared/services";

interface VisionboardItemSelectionData {
  forceVisionboardItemAddRemoveButton: ForceVisionboardItemAddRemoveButton;
}

@Component({
  selector: "app-visionboard-item-selection-dialog",
  templateUrl: "./visionboard-item-selection-dialog.component.html",
  styleUrls: ["./visionboard-item-selection-dialog.component.scss"],
  providers: [VisionboardItemAddRemoveButtonService],
  standalone: false,
})
export class VisionboardItemSelectionDialogComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();
  mobile: boolean;

  constructor(
    private _dialog: MatDialogRef<VisionboardItemSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VisionboardItemSelectionData,
    private visionboardCategoriesService: VisionboardCategoriesService,
    private scrollService: ScrollService,
    private _windowService: WindowService,
  ) {}

  ngOnInit(): void {
    this._dialog.disableClose = true;
    this._dialog.addPanelClass([DEFAULT_DIALOG_NO_PADDING_CLASS, "visionboard-item-selection-dialog"]);

    this._dialog
      .backdropClick()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this._dialog.close();
      });

    this.visionboardCategoriesService.selectedCategory$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: cat => {
        if (!cat || !cat[1]) {
          this._dialog.close();
        }
      },
    });

    this._windowService
      .observeMax$(576)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: m => {
          this.mobile = m.matches;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onCloseButtonClick(): void {
    this._dialog.close();
  }

  onItemClicked(item: VisionboardItem): void {
    this._dialog.close(item);
  }

  onItemResultsPaged(): void {
    setTimeout(() => {
      this.scrollService.scrollToTopOfElement(document.getElementById(this._dialog.id));
    }, 100);
  }

  onScrollerLoaded(): void {
    this._dialog.addPanelClass("has-item-scroller");
  }
}
